import sortBy from 'lodash-es/sortBy';
import { IUpdatePatternItem, UpdateType } from '../../sharedComponents/webglUtils';
import { NodeInternal } from './nodeFillShadersUtils';
const styles = require('./labels.css');

interface TextElemStyles {
  className: string;
  textContent: string;
  top: number;
  left: number;
}

const applyStyleToDOMNode = (domNode: HTMLDivElement, style: TextElemStyles) => {
  domNode.className = style.className;
  domNode.textContent = style.textContent;
  domNode.style.top = `${style.top}px`;
  domNode.style.left = `${style.left}px`;
};

export const getTextLabelFragment = (
    nextNodes: Map<string, NodeInternal>,
    updatePattern: IUpdatePatternItem[],
    maxNumLabels: number,
  ) => {
  const unsortedEnterOrUpdateNodes = updatePattern.filter(
    ({type}) => type === UpdateType.Enter || type === UpdateType.Update,
  );
  const reverseSortedEnterOrUpdateNodes = sortBy(unsortedEnterOrUpdateNodes, ({key}) => {
    const retrievedNode = nextNodes.get(key);
    if (retrievedNode === undefined) {
      throw new Error('Cannot retrieve node id ' + key);
    }
    return retrievedNode.radius;
  });
  const enterOrUpdateNodeIds = reverseSortedEnterOrUpdateNodes.reverse().map(({key}) => key);

  // Below, we're trying to find the top 2 contributing export products to be labeled on the graph:
  let largestContributingNodes: NodeInternal[] = [];
  for (const id of enterOrUpdateNodeIds) {
    const node = nextNodes.get(id);
    if (node !== undefined && node.contributingInfo.isAmongLargest === true) {
      largestContributingNodes.push(node);
    }
  }

  largestContributingNodes.sort((a, b) => {
    const aContributingInfo = a.contributingInfo;
    const bContributingInfo = b.contributingInfo;
    if (aContributingInfo.isAmongLargest === false || bContributingInfo.isAmongLargest === false) {
      throw new Error('Products that are not the largest contributors should have been filtered out');
    }
    const aIndex = aContributingInfo.index;
    const bIndex = bContributingInfo.index;
    return aIndex - bIndex;
  });

  if (largestContributingNodes.length > maxNumLabels) {
    largestContributingNodes = largestContributingNodes.slice(0, maxNumLabels);
  }

  const childrenNodes: HTMLDivElement[] = [];
  for (const node of largestContributingNodes) {
    const style: TextElemStyles = {
      className: styles.nodeLabel,
      textContent: node.label,
      top: node.centerY - node.radius,
      left: node.centerX,
    };
    const elem = document.createElement('div');
    applyStyleToDOMNode(elem, style);
    childrenNodes.push(elem);
  }

  const fragment = document.createDocumentFragment();
  const rootNode = document.createElement('div');
  rootNode.className = styles.masterContainer;

  childrenNodes.forEach(node => {
    rootNode.appendChild(node);
  });

  fragment.appendChild(rootNode);

  return {
    fragment, rootNode,
  };
};
